module.exports = __webpack_public_path__ + "img/algeria.5cc564d.webp";